"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDynamoDBClient = getDynamoDBClient;
exports.getDynamoDBDocClient = getDynamoDBDocClient;
const client_dynamodb_1 = require("@aws-sdk/client-dynamodb");
const lib_dynamodb_1 = require("@aws-sdk/lib-dynamodb");
function getDynamoDBClient() {
    const isLocal = process.env.LOCAL_AWS === "true";
    if (isLocal) {
        return new client_dynamodb_1.DynamoDBClient({
            region: "local",
            endpoint: "http://localhost:8000", // Point to DynamoDB Local instance
            credentials: {
                accessKeyId: "fake",
                secretAccessKey: "fake",
            },
        });
    }
    return new client_dynamodb_1.DynamoDBClient({
        region: process.env.AWS_REGION || "us-east-1",
    });
}
function getDynamoDBDocClient(ddbClient) {
    if (!ddbClient)
        ddbClient = getDynamoDBClient();
    return lib_dynamodb_1.DynamoDBDocumentClient.from(ddbClient);
}
//# sourceMappingURL=dynamoDBClient.js.map